import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { useApi } from "hooks/useApi";
import { useCache } from "hooks/useCache";
import { useMemo, useState } from "react";
import DashboardTable from "../DashboardTable";

type Table3RowType = {
  id: string;
  name: string;
  sub_area_name: string;
  last_activity: string;
  amount_due: any;
  cumulative_amount_due: any;
  tax_payment_status: string;
  tax_nature: string;
  due_date: string;
};

export default function TaxPayersTable(props:any) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [searchBarValue34, setSearchBarValue34] = useState("");
  const { getTaxPayers } = useApi();
  const { data: taxPayers, mutate } = useCache("getTaxPayers", () =>
    getTaxPayers(page, searchBarValue34, 5,"late")
  );
  const handleSearch = (event: any) => {
    // const value = event.target.value;
    // setSearchBarValue34(value);
    mutate(getTaxPayers(page, searchBarValue34, 5));
  };
  const handleClearSearch = (event: any) => {
    setSearchBarValue34("");
    mutate(getTaxPayers(page, ""));
  };

  const handleJumpToPage = (pg: number) => {
    setPage(pg);
    mutate(getTaxPayers(pg));
  };
  const handleSetNextPage = () => {
    if (taxPayers?.length > 0 && taxPayers[0].num_of_pages >= page + 1) {
      setPage((prev: any) => prev + 1);
      mutate(getTaxPayers(page + 1));
    }
  };
  const handleSetPrevPage = () => {
    if (taxPayers?.length > 0 && page > 0) {
      setPage((prev: any) => prev - 1);
      mutate(getTaxPayers(page + 1));
    }
  };
  const table3Columns = useMemo(() => {
    const table3ColumnHelper = createColumnHelper<Table3RowType>();
    return [
      table3ColumnHelper.accessor("name", {
        cell: (info) => (
          <Box flex={1}>
            <Flex gap="8px" alignItems="center" px="12px" py="0px">
              <Text style={{ textTransform: "capitalize" }}>
                {info.getValue<string>()}
              </Text>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px">
            <Heading as="h6">Nom</Heading>
          </Flex>
        ),
        meta: { width: "100px" },
      }),
      table3ColumnHelper.accessor("sub_area_name", {
        cell: (info) => (
          <Box flex={1}>
            <Flex gap="8px" alignItems="center" px="12px" py="0px">
              <Text style={{ textTransform: "capitalize" }}>
                {info.getValue<string>()}
              </Text>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px">
            <Heading as="h6">Zone</Heading>
          </Flex>
        ),
        meta: { width: "100px" },
      }),
      table3ColumnHelper.accessor("tax_nature", {
        cell: (info) => (
          <Flex px={{ base: "20px", sm: "24px" }}>
            <Text>{info.getValue<string>()}</Text>
          </Flex>
        ),
        header: (info) => (
          <Flex p="14px" px={"40px"}>
            <Heading as="h6">Nature de règlement</Heading>
          </Flex>
        ),
        meta: { width: "172px" },
      }),
      // table3ColumnHelper.accessor("due_date", {
      //   cell: (info) => (
      //     <Flex px={{ base: "20px", sm: "24px" }}>
      //       <Text>{info.getValue<string>()}</Text>
      //     </Flex>
      //   ),
      //   header: (info) => (
      //     <Flex p="14px" px={"40px"}>
      //       <Heading as="h6">Date d'échéance</Heading>
      //     </Flex>
      //   ),
      //   meta: { width: "170px" },
      // }),
      table3ColumnHelper.accessor("cumulative_amount_due", {
        cell: (info) => (
          <Box flex={1}>
            <Flex
              gap="8px"
              alignItems="center"
              px="12px"
              py="0px"
              justifyContent={"flex-end"}
            >
              <Text style={{ textTransform: "capitalize" }}>
                {info.getValue<string>()}
              </Text>
            </Flex>
          </Box>
        ),
        header: (info) => (
          <Flex flex={1} px={"25px"} py="14px" justifyContent={"flex-end"}>
            <Heading as="h6">Montant dû</Heading>
          </Flex>
        ),
        meta: { width: "120px" },
      }),
    ];
  }, []);

  return (
    <>
      <DashboardTable
        title="Débiteurs en impayé"
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        handleJumpToPage={handleJumpToPage}
        handleSearch={handleSearch}
        handleSetNextPage={handleSetNextPage}
        handleSetPrevPage={handleSetPrevPage}
        handleClearSearch={handleClearSearch}
        tableColumns={table3Columns}
        tableData={taxPayers}
        searchKey={searchBarValue34}
        setSearchKey={setSearchBarValue34}
      />
    </>
  );
}
